import React, { Component } from 'react';
import { PageSection, IconCircleExclamation } from 'adc-ui-components';

import { kibanaLog } from '../../helpers/logger';

class PermsError extends Component {
  componentDidMount() {
    // todo, make this better
    kibanaLog('perms_error');
  }

  render() {
    return (
      <PageSection className="ui-grey page-section--banner">
        <IconCircleExclamation className="mb12 svg-icon--42" />

        <div className="mb24">
          <h1 className="heading2 mb6">Restricted Section</h1>
          <p className="body2">You cannot access restricted areas of My Account</p>
        </div>

        <a className="button button--primary" href="/">Back to My Account</a>
      </PageSection>
    );
  }
}

export default PermsError;
